import { apiUrl } from "../utils/api";

/** Unterschrift (gehört einem Nutzer) oder Stempel (gehört dem Büro). */
export type BausteinArt = "unterschrift" | "stempel";

/** Spiegel von `PdfBausteinDto` im Backend (`pdf-bausteine/pdf-baustein.service.ts`). */
export interface PdfBaustein {
    id: number;
    art: BausteinArt;
    name: string;
    /** `data:image/png|jpeg;base64,…` — Text-Stempel: null. */
    bildDataUrl: string | null;
    /** Zeilen mit `\n`. */
    text: string;
    /** `#rrggbb` */
    farbe: string;
    mitDatum: boolean;
    handschrift: boolean;
    sortierung: number;
    /** Darf ich ihn ändern/löschen? Stempel nur admin/gfgl, Unterschriften immer (nur eigene sichtbar). */
    eigen: boolean;
    /** Letzte Änderung (ISO) — Schlüssel für zwischengespeicherte Vorschaubilder. */
    geaendert: string | null;
}

/** Spiegel von `BausteinEingabe` im Backend (`pdf-baustein.regeln.ts`). */
export interface BausteinEingabe {
    art: BausteinArt;
    name: string;
    bildDataUrl: string | null;
    text: string;
    farbe: string;
    mitDatum: boolean;
    handschrift: boolean;
}

/** Der Server sagt, was nicht passt („Ein Stempel braucht ein Bild oder Text.“) — das reichen wir durch. */
async function antwort<T>(res: Response, fallback: string): Promise<T> {
    if (!res.ok) {
        const grund = await res
            .json()
            .then((b: { message?: unknown }) =>
                Array.isArray(b?.message) ? b.message.join(", ") : typeof b?.message === "string" ? b.message : "",
            )
            .catch(() => "");
        throw new Error(grund || `${fallback}: ${res.status}`);
    }
    return res.json() as Promise<T>;
}

const json = (method: string, body: unknown): RequestInit => ({
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
});

export const pdfBausteinService = {
    async liste(): Promise<PdfBaustein[]> {
        return antwort(await fetch(apiUrl("pdf-bausteine")), "Unterschriften und Stempel konnten nicht geladen werden");
    },
    async anlegen(e: BausteinEingabe): Promise<PdfBaustein> {
        return antwort(await fetch(apiUrl("pdf-bausteine"), json("POST", e)), "Anlegen fehlgeschlagen");
    },
    async aendern(id: number, e: BausteinEingabe): Promise<PdfBaustein> {
        return antwort(await fetch(apiUrl(`pdf-bausteine/${id}`), json("PUT", e)), "Speichern fehlgeschlagen");
    },
    async loeschen(id: number): Promise<void> {
        await antwort(await fetch(apiUrl(`pdf-bausteine/${id}`), { method: "DELETE" }), "Löschen fehlgeschlagen");
    },
};
